export const bookingConfig = {
  // Business hours (UK time - 24hr format)
  businessHours: {
    monday: { start: 9, end: 22 },
    tuesday: { start: 9, end: 22 },
    wednesday: { start: 9, end: 22 },
    thursday: { start: 9, end: 22 },
    friday: { start: 9, end: 22 },
    saturday: { start: 9, end: 22 },
    sunday: null, // Closed
  },

  // Duration options (in minutes)
  durations: [
    { value: 30, label: "30 Minutes - Quick Strategy Session" },
    { value: 60, label: "60 Minutes - Deep Dive Consultation" },
  ],

  // Booking settings
  maxDaysInAdvance: 60,
  bufferBetweenCalls: 15, // minutes
  slotInterval: 30, // Show slots every 30 minutes

  // Contact info
  contactEmail: "info@ascencio.co.uk",
  contactPhone: "+1 (662) 493-4617",
  timezone: "Europe/London",
};
